import { render, staticRenderFns } from "./stockTaking.vue?vue&type=template&id=07273a1c"
import script from "./stockTaking.vue?vue&type=script&lang=js"
export * from "./stockTaking.vue?vue&type=script&lang=js"
import style0 from "./stockTaking.vue?vue&type=style&index=0&id=07273a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports